import { getTimeZoneByGeoLocation } from 'async-timing';

export default function getTimeZoneFromPort(port: any) {
  const [longitude, latitude] = port?.address?.geo || [null, null];

  return getTimeZoneByGeoLocation({ longitude, latitude });
}
